import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';

import { Platform, Events, NavController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ApiService } from './services/api.service';
import { User } from './models/User';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';
import { environment } from "../environments/environment";
import { Stripe } from '@ionic-native/stripe/ngx';
import { AuthenticationService } from './services/authentication.service';
import { Storage } from '@ionic/storage';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilitiesService } from './services/utilities.service';
import * as moment from 'moment';
import { AppVariablesService } from './services/app-variables.service';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  user: User;
  public isLoading: boolean = true;
  lastRoute: string;
  public appPages = [
    {
      title: 'Inicio',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Perfil',
      url: '/profile',
      icon: 'person'
    },
    {
      title: 'Chats',
      url: '/chats',
      icon: 'chatboxes'
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private apiService: ApiService,
    private push: Push,
    private router: Router,
    private zone: NgZone,
    private events: Events,
    private stripe: Stripe,
    private auth: AuthenticationService,
       private cdr: ChangeDetectorRef,
    private navCtrl: NavController,
    private storage: Storage,
    private translate: TranslateService,
    private utilities: UtilitiesService,
    private appVariables: AppVariablesService
  ) {
    const idiomaGuardado = localStorage.getItem('idioma');
    console.log('Idioma armazenado:', idiomaGuardado);

    if (idiomaGuardado) {
      this.translate.use(idiomaGuardado).subscribe(() => {
        moment.locale(idiomaGuardado);
        console.log('Idioma carregado:', idiomaGuardado);
        this.cdr.detectChanges();
      });
    } else {
      this.translate.use('es').subscribe(() => {
        moment.locale('es');
        console.log('Idioma padrão aplicado: es');
        this.cdr.detectChanges();
      });
    }
  }

  /**
   * Nos suscribimos a los cambios dle perfil
   */
  async ngOnInit() {
    
    document.body.classList.remove('dark');
    document.body.classList.add('light');

  this.inicializateApp();
  this.restoreRouteOnReload();



  moment.locale('es');
  this.restoreAuthState()
    this.auth.authenticationState.subscribe(token => {
       console.log("TOKEN", token);
      if (token != 'logout' && token != '') {
        this.pushNotifications();
        //this.prepararStripe();
        this.apiService.setTokenToHeaders(token);
        this.navCtrl.navigateRoot('/tabs/profile').then(() => {
          this.isLoading = false;
        });
        this.apiService.getEntity('user').subscribe(user => {
          this.appVariables.user = user;
          this.appVariables.user.api_token = token;

          console.log('aqui en appVariables.user');
          console.log(this.appVariables.user);
        })
      } else if (token == 'logout') {
        this.apiService.removeTokenToHeaders();
        localStorage.setItem('auth_token', '');
        this.navCtrl.navigateRoot('cover-page').then(() => {
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
        console.log("primera vez");
      }

      // IMPORTANTE: para comprobar si la app está o no suspendida, debe ponerse el dominio en la propiedad "domainUrl" del archivo "src/environments/environment.ts"
      // this.checkIfAppIsSuspended();
    });

    if (this.platform.is('cordova')) {
      this.platform.ready().then(() => {
        this.statusBar.styleBlackOpaque();
        this.splashScreen.hide();
      });
    }

    this.apiService.userChanges.subscribe((user: User) => {
      this.user = user;
    });
  
}



  /**
   * Comprueba si el dominio de la aplicación está suspendido. Si lo está, muestra un mensaje de aviso al usuario
   */
  public checkIfAppIsSuspended() {
    this.apiService.checkAppDomain().subscribe(async (response) => {
      // no hacemos nada, ya que el dominio de la aplicación estaría activado
    },
      async (errorResponse: HttpErrorResponse) => {
        if (errorResponse.status == 0 || errorResponse.status == 403) {
          this.utilities.showAlert('Esta app no ha sido renovada', 'Si usted es el propietario, por favor hable con nosotros en el 956 105 343 para renovar el servicio o contacte con facturacion@xerintel.es', false);
        }
      })
  }


  private restoreAuthState() {
    const token = localStorage.getItem('auth_token');
    if (token) {
     console.log("Restaurando estado de autenticação com o token do localStorage.");
      this.auth.login(token); // Atualiza o estado do serviço de autenticação.
    }
  }

  /**
   * Configuración de las notificación push
   */
  public pushNotifications(): void {

    const options: PushOptions = {
      android: {
        senderID: environment.senderID,
        icon: 'notification'
      },
      ios: {
        alert: 'true',
        badge: true,
        sound: 'true',
      },
      windows: {},
    }

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification) => {
      if(notification.additionalData.foreground) {
        this.utilities.showAlert(notification.title, notification.message);
      }
    });

    pushObject.on('registration').subscribe((registration) => {
      const regId = registration.registrationId;
      this.apiService.guardarTokenDeRegistro(regId).subscribe((response) => {
        console.log(response);
      }, (error) => {
        console.log(error);
      })
    });

    pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));
  }

  /**
   * Preparamos stripe con su configuración
   */
  public prepararStripe(): void {
    this.stripe.setPublishableKey(environment.stripePublishableKey);
  }


  inicializateApp() {
    this.platform.ready().then(() => {
      this.restoreRouteOnReload();
    });
  
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('Navegando para:', event.urlAfterRedirects);
        localStorage.setItem('lastRoute', event.urlAfterRedirects);
      }
    });
  }
  
  // handleAppUrlOpen() {
  //   App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
  //     this.zone.run(() => {
  //       const url = event.url;
  //       console.log('App URL received:', url);
  //       const domain = 'http://localhost:8100'; //LARISSA PONER O DOMINIO DE LA PAGINA
  //       const pathArray = event.url.split(domain);
  //       const appPath = pathArray.pop();
  //       if (appPath) {
  //         console.log('App URL open:', appPath);
  //         this.router.navigateByUrl(appPath);
  //       }
  //     });
  //   });
  // }

  restoreRouteOnReload() {
    this.platform.ready().then(() => {
      const lastRoute = localStorage.getItem('lastRoute');
      console.log('Última rota recuperada:', lastRoute);
  
      if (lastRoute && lastRoute !== '/') {
        setTimeout(() => { // Evita navegação antes da inicialização completa
          this.zone.run(() => {
            this.router.navigateByUrl(lastRoute);
          });
        }, 500);
      } else {
        console.log('Nenhuma rota armazenada. Redirecionando para /home');
        this.router.navigateByUrl('/home');
      }
    });
  }
  

}
